import _ from 'lodash';
import { useState } from 'react';
import { getEnvironments, getEnvironmentCost, getIndexes, getS3Cost } from '../../helpers/api';
import { getLastMonthDates } from '../../helpers/utils';


export default function computeCost() {
  const [envData, setEnvData] = useState([]);

  async function getEnvData() {
    const { startDate, endDate } = getLastMonthDates();	  
    const allEnvironments = await getEnvironments();
    const indexes = await getIndexes();
    const s3cost = await getS3Cost(indexes[0].id);

    // only show last month of env data	  
    const lastMthFirstDay=Date.parse(startDate);
    const lastMthLastDay=Date.parse(endDate);	  
    const envs = _.filter(allEnvironments, (env) =>  { 
	const createdDate = Date.parse(env.createdAt);    
	return createdDate >= lastMthFirstDay && createdDate <= lastMthLastDay 
    });
    const envCostIdToName = {};
    const envCostNameToIndex = {};
    envs.forEach(env => {
      envCostIdToName[env.id] = env.name;
      envCostNameToIndex[env.name] = env.indexId;
    });

    const envCostIds = Object.keys(envCostIdToName);
    const allEnvCosts = envCostIds.map(envId => {
      return getEnvironmentCost(envId, true, false);
    });

    const envCosts = await Promise.all(allEnvCosts);
    const envCostItems = envs.map((item, index) => {
      item.costs = envCosts[index];
      const found = _.filter(s3cost, { envId: item.id });
      if (found) {
	   const s3costs = _.map(found, 'totalCost');   
	   const totalCost = s3costs.reduce((a, b) => a + b, 0);   
	   item.costs.push({"startDate":(new Date()).toISOString().slice(0,10),"cost":{"S3":{"amount":totalCost,"unit":"USD"}}});
      }
      return item;
    })

    setEnvData(envCostItems);
  }

  return [envData, getEnvData];
}
